module.exports = __webpack_public_path__ + "img/product_120.3903893.svg";